import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../../store/SelectionSliceFor';

const entityKey = 'code-pipelines';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const CodePipelinesReducer = combineReducers({
    selection: selectionSlice.reducer,
});
